<template>
    <div class="grid grid-cols-5 gap-2 overflow-x-auto">
        <div class="bg-white grid grid-cols-1 items-center min-w-fit text-sm"  v-for="(c,i) in Card" :key="i">
            <div class="flex justify-start items-center h-full p-2 border-b border-next-light-gray">
                <b>{{ c.title }}</b> :  {{ c.valore }}
            </div>
        </div>
        <div class="bg-white grid grid-cols-1 items-center min-w-fit text-sm"  @click="$emit('clickFee')">
            <div class="flex justify-start items-center h-full p-2 border-b border-next-light-gray">
                <b>Fee</b> :  <span class="text-sm whitespace-nowrap">{{ fee }} €</span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import CardDivisorioGrigio from "@/components/CardDivisorioGrigio.vue";
import {mapGetters} from 'vuex';

@Options({
    name: 'SottoProgettoHead',
    components: {
        CardDivisorioGrigio
    },
    props: {
        budget: String,
        totaleCosti: String,
        risorseInterne: [String, Number],
        totaleRicavi: String,
        budgetProgetto: String,
        commissioni: String,
        secondoMargine: String,
        totaleRisorse: String,
        utile: String,
        margine: String,
        fee: String,
    },
    computed: {
        ...mapGetters('sprjDataManager', [
            'VeBudget',
        ]),
    },

})
export default class SottoProgettoHead extends Vue {

    budget!: any
    totaleCosti!: any
    totaleRicavi!: any
    budgetProgetto!: any
    secondoMargine!: any
    totaleRisorse!: any
    utile!: any
    commissioni!: any
    margine!: any
    VeBudget!: any

    get Card() {
        return [
            {title: "Budget di apertura", valore: this.budget},
            {title: "Totale ricavi", valore: this.totaleRicavi},
            {title: "Budget progetto", valore: this.budgetProgetto},
            {title: "Commissioni", valore: this.commissioni},
            {title: "Totale costi", valore: this.totaleCosti},
            {title: "Primo margine", valore: this.utile},
            {title: "Primo margine %", valore: this.margine},
            {title: "Totale costo r.i.", valore: this.totaleRisorse},
            {title: "Secondo margine", valore: this.secondoMargine},
        ]
    }
}

</script>

<style lang="scss">

</style>
